import { useTranslation } from 'react-i18next';

import { AltaVisitorSvg } from 'components/svgs/AltaVisitorSvg';
import { OpBlurbPage } from 'new-components/OpBlurbPage/OpBlurbPage';

import visitorBlurbCover from '../../../partnerCenterApp/assets/partner-visitor-blurb-cover.png';

const VISITOR_MARKETING_URL = 'https://security.avigilon.com/alta-visitor';

export default () => {
  const { t } = useTranslation();

  /* This part will be updated
    const { orgId } = getOpParams();
    const { data: org } = useOpQuery({
        apiEndpointName: 'describeOrg',
        parameters: [orgId],
        select: (heliumResponse) => heliumResponse.json.data,
    });
    {
    */

  const content = [
    t(
      'Transform guest experiences with our new visitor management system. Streamline check-ins, enhance security, and make a lasting first impression.',
    ),
  ];

  return (
    <OpBlurbPage
      externalLinkButtonTestId={'visitor-welcome'}
      externalLink={VISITOR_MARKETING_URL}
      coverImage={visitorBlurbCover}
      title={t('Alta Visitor')}
      avatarComponent={<AltaVisitorSvg />}
      ctaButton={undefined}
      content={content}
    />
  );
};
